import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2d17e3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_z_pin = _resolveComponent("z-pin")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ion_grid, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pins, (pin) => {
              return (_openBlock(), _createBlock(_component_ion_col, {
                class: "ion-no-padding",
                size: "4",
                "size-md": "2",
                key: pin.id
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  (_openBlock(), _createBlock(_component_z_pin, {
                    onClick: ($event: any) => ($options.openPin(pin)),
                    pin: pin,
                    class: "box",
                    module: $props.module,
                    key: pin.id
                  }, null, 8, ["onClick", "pin", "module"]))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    ($props.infinite)
      ? (_openBlock(), _createBlock(_component_ion_infinite_scroll, {
          key: 0,
          onIonInfinite: _cache[0] || (_cache[0] = ($event: any) => ($options.loadData($event))),
          threshold: "100px",
          id: "infinite-scroll",
          disabled: $options.allDataLoaded
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_infinite_scroll_content, {
              "loading-spinner": "null",
              "loading-text": ""
            })
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}